import HTTP from '@/utils/http-common';
import { createSocketRequest } from '@mtntop/utils/src/plugins/socket';

import { encodeOpts } from '../utils/encode-opts';
const config = { headers: { 'Content-Type': 'multipart/form-data' } };

const createStore = (store) => HTTP.post('/stores', store);
const updateStore = (store) => HTTP.put('/stores', store);
const updateStoreField = (storeId, data) => HTTP.patch(`/stores/${storeId}`, data);
const getStoreCategories = async (storeId, params = {}) =>
  (
    await HTTP.get(`/stores/${storeId}/categories`, {
      params: { limit: 1000, orderBy: 'name', ascending: 1, ...params },
      paramsSerializer: encodeOpts
    })
  ).data.data;
const setProductStoreCategory = (storeId, productId, categoryId, remove = false) =>
  HTTP.post(`/stores/${storeId}/products/categories${remove ? '?remove=true' : ''}`, [{ productId, categoryId }]);
const getOneStore = async (storeId) => (await HTTP.get(`/stores/${storeId}`)).data;
const getStoreSetupStatus = async (storeId) => (await HTTP.get(`/stores/${storeId}/setup-status`)).data;
const getStorePreviewToken = async (storeId) => (await HTTP.get(`/stores/${storeId}/preview-token`)).data;
const getStorePreviewUrl = async (storeId, pageId) => (await HTTP.get(`/stores/${storeId}/preview-url/${pageId}`)).data;
const deleteStore = (storeId) => HTTP.delete(`/stores/${storeId}`);
const createStoreContact = (email) => HTTP.post('/stores/contacts', email);
const verifyStoreContact = (storeId, emailId) => HTTP.put(`/stores/${storeId}/contacts/${emailId}/verify`);
const updateStoreContact = (email) => HTTP.put('/stores/contacts', email);
const deleteStoreContact = (emailId) => HTTP.delete(`/stores/contacts/${emailId}`);
const createStoreEmail = (email) => HTTP.post('/stores/emails', email);
const updateStoreEmail = (email) => HTTP.put('/stores/emails', email);
const deleteStoreEmail = (emailId) => HTTP.delete(`/stores/emails/${emailId}`);
const createStoreSocialAuth = async (auth) => (await HTTP.post('/stores/sso-creds', auth)).data;
const updateStoreSocialAuth = (auth) => HTTP.put('/stores/sso-creds', auth);
const deleteStoreSocialAuth = (authId) => HTTP.delete(`/stores/sso-creds/${authId}`);
const createStoreHeadTag = (tag) => HTTP.post('/stores/headtags', tag);
const updateStoreHeadTag = (tag) => HTTP.put('/stores/headtags', tag);
const deleteStoreHeadTag = (storeId, tagId) => HTTP.delete(`/stores/${storeId}/headtags/${tagId}`);
const createStorePaymentMethod = (payment) => HTTP.post('/stores/payments', payment);
const updateStorePaymentMethod = (payment) => HTTP.put('/stores/payments', payment);
const assingGlobalCategoriesOnStore = (data) => HTTP.post('/stores/categories/assign-global', data);
const deleteStorePaymentMethod = (type, paymentId) => HTTP.delete(`/stores/payments/${type}/${paymentId}`);
const createStoreComponent = (component) => HTTP.post('/store/components', component);
const updateStoreComponent = (component) => HTTP.put('/store/components', component);
const updateStoreComponentField = (data) => HTTP.patch('/store/components', data);
const deleteStoreComponent = (componentId, params) =>
  HTTP.delete(`/store/components/${componentId}`, {
    params,
    paramsSerializer: encodeOpts
  });
const restoreStoreComponent = async componentId => (await HTTP.post(`/store/components/${componentId}/restore`)).data;
const getStoreComponentById = async (componentId, params) =>
  (
    await HTTP.get(`/store/components/${componentId}`, {
      params,
      paramsSerializer: encodeOpts
    })
  ).data;
const getStoreComponents = (storeId, params) => HTTP.get(`/store/components/by-store/${storeId}`, params);
const uploadStoreComponentMedia = (formData) => HTTP.post('/store/components/media', formData, config);
const deleteStoreComponentMedia = (mediaId, componentId) =>
  HTTP.delete(`/store/components/media/${componentId}/${mediaId}`);
const uploadStoreMedia = (formData) => HTTP.post('/stores/media', formData, config);
const addStoreMediaFromUrl = media => HTTP.post('/stores/media/from-url', media);
const deleteStoreMedia = (mediaId, storeId) => HTTP.delete(`/stores/${storeId}/media/${mediaId}`);
const uploadStoreSiteMap = (formData, files) => HTTP.post('/stores/sitemaps', formData, files, config);
const uploadStoreMainSiteMap = (storeId, siteMap) => HTTP.patch(`/stores/${storeId}/sitemaps/upload`, siteMap);
const downloadStoreSiteMap = (storeUrl, data) => HTTP.post(`/stores/${storeUrl}/sitemaps/download`, data);
const uploadStoreRobots = (storeId, robots) => HTTP.patch(`/stores/${storeId}/robots/upload`, robots);
const downloadStoreRobots = (storeUrl, data) => HTTP.post(`/stores/${storeUrl}/robots/download`, data);
const deleteStoreSiteMap = (siteMapId, storeId) => HTTP.delete(`/stores/${storeId}/sitemaps/${siteMapId}`);
const updateStoreSiteMap = (siteMap) => HTTP.put(`/stores/sitemaps/${siteMap._id}`, siteMap);
const getDistributorStores = async (distributorId, params = {}) =>
  (
    await HTTP.post(`/stores/distributors/${distributorId}`, {
      params: {
        limit: 100,
        orderBy: 'name',
        noCount: true,
        withCategories: true,
        project: [
          'storeUrl',
          '_id',
          'storeName',
          'distributorId',
          'showDecoratedPricesOnProductList',
          'aiSearchEnabled',
          'aiImageSearchEnabled'
        ],
        ...params
      },
      paramsSerializer: encodeOpts
    })
  ).data.data;

const getSupplierStores = async (supplierId, params = {}) =>
  (
    await HTTP.get(`/stores/suppliers/${supplierId}`, {
      params: { limit: 1000, orderBy: 'name', ...params },
      paramsSerializer: encodeOpts
    })
  ).data;

const getStoreProducts = async (storeId, params = {}) =>
  (
    await HTTP.post(`/stores/${storeId || '-1'}/store-products`, {
      params,
      paramsSerializer: encodeOpts
    })
  ).data;

const aiProductsImageSearch = async (storeId, formData) =>
  (await HTTP.post(`/stores/${storeId}/products-ai-image-search`, formData, config)).data;

const getStoreCategoryProducts = async (storeId, categorySlug, params = {}) =>
  (
    await HTTP.get(`/stores/${storeId}/categories/${categorySlug}/productItems`, {
      params,
      paramsSerializer: encodeOpts
    })
  ).data;
const getStoreRoles = async (params = {}) =>
  (
    await HTTP.get(`/store-roles`, {
      params: params,
      paramsSerializer: encodeOpts
    })
  ).data;

const getStoreArtworks = async (storeId, params = {}) => (await HTTP.get(`/stores/${storeId}/artworks`, { params })).data;
const createStoreArtwork = async (storeId, artwork) => (await HTTP.post(`/stores/${storeId}/artworks`, artwork)).data;
const removeStoreArtwork = (storeId, artworkId) => HTTP.delete(`/stores/${storeId}/artworks/${artworkId}`);
const updateStoreArtwork = (storeId, artwork) => HTTP.put(`/stores/${storeId}/artworks/${artwork._id}`, artwork);
const updateStoreArtworkPreview = (formData) =>
  HTTP.post(`/stores/${formData.get('storeId')}/artworks/${formData.get('mediaId')}/preview`, formData, config);
const getDraftComponentByLive = async (componentId, params) =>
  (
    await HTTP.get(`/store/components/${componentId}/draft`, {
      params,
      paramsSerializer: encodeOpts
    })
  ).data;

const createStoreDraftComponent = async (data) => (await HTTP.post('/store/components/draft', data)).data;
const updateStoreDraftComponent = async (componentId, data) =>
  (await HTTP.put(`/store/components/${componentId}/draft`, data)).data;
const swapStoreComponents = async (data) => (await HTTP.put(`/store/components/swap`, data)).data;
const duplicateProductsCategories = async (data) => (await HTTP.post('/stores/products/duplicate', data)).data;
const duplicatePageForStores = async (pageId) => (await HTTP.post(`/stores/pages/${pageId}/duplicate`)).data;
const getDefaultGlobalStore = async () => (await HTTP.get('/store/global')).data;
const getStoreUserCommision = async () => (await HTTP.get('/store-users-commissions')).data;
const createStoreUserCommision = async (data) => (await HTTP.post('/store-user-commissions', data)).data;
const updateStoreUserCommision = async (data) => (await HTTP.put(`/store-user-commissions/${data._id}`, data)).data;
const getStoreExcludeSuppliersCount = async (storeId) =>
  (await HTTP.get(`/stores/${storeId}/exclude-suppliers/count`)).data;

const getApparelSizes = async (names) =>
  (await HTTP.post('/stores/apparel-sizes', { names: names?.length ? names : undefined })).data;
const searchStoreBillingStripeCustomers = async (storeId, query = '') =>
  (await HTTP.get(`/stores/${storeId}/billing/stripe-customers`, { params: { query } })).data;
const getStoreBillingComments = async (storeId) => (await HTTP.get(`/stores/${storeId}/billing/comments`)).data;
const addStoreBillingComment = async (storeId, text) =>
  (await HTTP.post(`/stores/${storeId}/billing/comments`, { text })).data;
const getStoreBillingDocuments = async (storeId) => (await HTTP.get(`/stores/${storeId}/billing/documents`)).data;
const addStoreBillingDocument = async (storeId, document) =>
  (await HTTP.post(`/stores/${storeId}/billing/documents`, document)).data;
const getStoreBillingTerms = async (storeId) => (await HTTP.get(`/stores/${storeId}/billing/terms`)).data;
// MP-9509 owns this route; until it ships a 404 or error reads as no saved methods
const getStoreBillingPaymentMethods = async (storeId) => {
  try {
    const { data } = await HTTP.get(`/stores/${storeId}/billing/payment-methods`);
    return Array.isArray(data) ? data : data?.paymentMethods || [];
  } catch (e) {
    return [];
  }
};

const getStoreBillingSubscription = async (storeId) =>
  (await HTTP.get(`/stores/${storeId}/billing/subscription`)).data;
const createStoreBillingSubscription = async (storeId) =>
  (await HTTP.post(`/stores/${storeId}/billing/subscription`)).data;

const getStoreCustomCss = async (storeId) => {
  try {
    return (await HTTP.get(`/stores/${storeId}/styles/custom.css`)).data;
  } catch (err) {
    if (err?.status === 404) return '';
    throw err;
  }
};
const updateStoreCustomCss = async (storeId, css) => (await HTTP.put(`/stores/${storeId}/styles/custom`, { css })).data;
const getStoreFontsSettings = async storeId => (await HTTP.get(`/stores/${storeId}/styles/fonts/settings`)).data;
const updateStoreFonts = async (storeId, fonts) => (await HTTP.put(`/stores/${storeId}/styles/fonts`, { fonts })).data;

export {
  getDistributorStores,
  getSupplierStores,
  getStoreCategories,
  setProductStoreCategory,
  createStore,
  updateStore,
  updateStoreField,
  getOneStore,
  getStoreSetupStatus,
  getStorePreviewToken,
  getStorePreviewUrl,
  deleteStore,
  createStoreEmail,
  updateStoreEmail,
  deleteStoreEmail,
  verifyStoreContact,
  createStoreContact,
  updateStoreContact,
  deleteStoreContact,
  createStoreSocialAuth,
  updateStoreSocialAuth,
  deleteStoreSocialAuth,
  createStoreHeadTag,
  updateStoreHeadTag,
  deleteStoreHeadTag,
  createStoreComponent,
  updateStoreComponent,
  deleteStoreComponent,
  restoreStoreComponent,
  createStorePaymentMethod,
  updateStorePaymentMethod,
  deleteStorePaymentMethod,
  getStoreComponents,
  uploadStoreComponentMedia,
  deleteStoreComponentMedia,
  uploadStoreMedia,
  addStoreMediaFromUrl,
  deleteStoreMedia,
  uploadStoreSiteMap,
  deleteStoreSiteMap,
  updateStoreSiteMap,
  getStoreProducts,
  aiProductsImageSearch,
  getStoreCategoryProducts,
  uploadStoreMainSiteMap,
  uploadStoreRobots,
  downloadStoreSiteMap,
  downloadStoreRobots,
  getStoreRoles,
  getStoreArtworks,
  createStoreArtwork,
  removeStoreArtwork,
  updateStoreArtwork,
  updateStoreArtworkPreview,
  updateStoreComponentField,
  getStoreComponentById,
  assingGlobalCategoriesOnStore,
  getDraftComponentByLive,
  createStoreDraftComponent,
  updateStoreDraftComponent,
  swapStoreComponents,
  duplicateProductsCategories,
  duplicatePageForStores,
  getDefaultGlobalStore,
  getStoreUserCommision,
  createStoreUserCommision,
  updateStoreUserCommision,
  getStoreExcludeSuppliersCount,
  getApparelSizes,
  searchStoreBillingStripeCustomers,
  getStoreBillingComments,
  addStoreBillingComment,
  getStoreBillingDocuments,
  addStoreBillingDocument,
  getStoreBillingTerms,
  getStoreBillingPaymentMethods,
  getStoreBillingSubscription,
  createStoreBillingSubscription,
  getStoreCustomCss,
  updateStoreCustomCss,
  getStoreFontsSettings,
  updateStoreFonts
};
